import { withInstall } from '../../../utils/with-install'
import ThreeLightHemisphere from './ThreeLightHemisphere.vue'

export const ElAmapThreeLightHemisphere = withInstall(ThreeLightHemisphere)
export default ElAmapThreeLightHemisphere
